import { forwardRef, useRef, useState } from 'react';
import { useKeyPress } from 'ahooks';
import { Flex, Input, SVGPureIcon } from '..';

const Search = forwardRef((props, ref) => {
  const { onSearch, onChange, ...resetProps } = props;
  const valRef = useRef('');

  const handleSearchClick = () => {
    onSearch?.(valRef.current);
  };

  useKeyPress('Enter', handleSearchClick);

  const handleChange = (event) => {
    const value = event.target.value;
    valRef.current = value;

    onChange?.(event);
  };

  const renderSuffix = () => {
    return (
      <Flex
        className={[
          'group',
          'h-full',
          'items-center',
          'px-10px',
          'cursor-pointer',
        ]}
        onClick={handleSearchClick}
      >
        <SVGPureIcon
          name="search"
          size={20}
          className="cursor-pointer"
          iconClass={[
            'group-hover:white',
            // 'group-hover:text-primary-normal',
          ]}
        />
      </Flex>
    );
  };

  return (
    <Input
      ref={ref}
      inputClass="pr-0"
      suffix={renderSuffix()}
      onChange={handleChange}
      {...resetProps}
    />
  );
});

export default Search;
